import {
  ADD_TO_WISHLIST,
  REMOVE_FROM_WISHLIST,
  CLEAR_WISHLIST,
  GET_WISHLIST,
  SET_WISHLIST,
  TOGGLE_WISHLIST,
  SET_WISHLIST_LOADING,
} from "../../actions";

const initialState = {
  items: [],
  loading: true,
};

const wishlistReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_WISHLIST: {
      if (!state.items.includes(action.payload)) {
        return {
          ...state,
          items: [...state.items, action.payload],
        };
      }
      return state;
    }

    case REMOVE_FROM_WISHLIST: {
      return {
        ...state,
        items: state.items.filter((item) => item?.id !== action.payload),
      };
    }

    case CLEAR_WISHLIST: {
      return {
        ...state,
        items: [],
      };
    }
    // ✅ new: get all wishlist items
    case GET_WISHLIST: {
      return {
        ...state,
        items: state.items, // just return current state
      };
    }

    case SET_WISHLIST_LOADING:
      return { ...state, loading: action.payload };

    case SET_WISHLIST:
      return { ...state, items: action.payload, loading: false };

    // ✅ toggle wishlist item
    case TOGGLE_WISHLIST: {
      const exists = state.items.find((item) => item.id === action.payload.id);
      if (exists) {
        // remove if already in list
        return {
          ...state,
          items: state.items.filter((item) => item.id !== action.payload.id),
        };
      } else {
        // add if not in list
        return {
          ...state,
          items: [...state.items, action.payload],
        };
      }
    }

    default:
      return state;
  }
};

export default wishlistReducer;
